import img1 from "../../img/img1.jpg"
import img2 from "../../img/img2.jpg"
import img3 from "../../img/img3.jpg"
import img4 from "../../img/img4.jpg"
import img5 from "../../img/img5.jpg"
import img6 from "../../img/background.jpg"
import img7 from "../../img/slider1.jpg"
import img8 from "../../img/slider2.jpg"
import img9 from "../../img/slider3.jpg"

 const Data = [
    {
        id: 1,
        img: img1,
        alt: "galeria" 
    },
    {
        id: 2,
        img: img2,
        alt: "galeria"
    },
    {
        id: 3,
        img: img3,
        alt: "galeria" 
    },
    {
        id: 4,
        img: img4,
        alt: "galeria" 
    },
    {
        id: 5,
        img: img5,
        alt: "galeria" 
    },
    {
        id: 6,
        img: img6,
        alt: "galeria" 
    },
    {
        id: 7,
        img: img7,
        alt: "galeria" 
    },
    {
        id: 8,
        img: img8,
        alt: "galeria" 
    },
    {
        id: 9,
        img: img9,
        alt: "galeria" 
    }
]

export default Data;